import { render, staticRenderFns } from "./uilchilgeenii_nuhtsul.vue?vue&type=template&id=f8c3606e&"
import script from "./uilchilgeenii_nuhtsul.vue?vue&type=script&lang=js&"
export * from "./uilchilgeenii_nuhtsul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports